import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Logo, StripeBand } from '@/design/components';
import { useSettings } from '@/access/SettingsContext';
import { isValidPhone } from '@/lib/phone';
import { requestOtp } from './api';

/** מסך הכניסה. אחד משלושת המקומות שבהם מופיעים הפסים האלכסוניים. */
export function LoginPage() {
  const navigate = useNavigate();
  const { brand } = useSettings();
  const [phone, setPhone] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSending, setIsSending] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setIsSending(true);
    const result = await requestOtp(phone);
    setIsSending(false);

    if (result.ok) {
      navigate('/login/code', { state: { phone } });
    } else {
      setError(result.message);
    }
  }

  return (
    <div className="grid min-h-dvh grid-rows-[auto_1fr] bg-surface">
      <div className="bg-charcoal">
        <div className="flex h-40 items-center justify-center">
          <Logo on="charcoal" height={44} />
        </div>
        <StripeBand />
      </div>

      <main className="mx-auto grid w-full max-w-md content-start gap-6 p-4 pt-8">
        <div className="grid gap-2">
          <h1 className="m-0 font-display text-display-l font-semibold">כניסה לאפליקציה</h1>
          <p className="m-0 text-body text-muted">
            הזן/י את מספר הטלפון שלך, ונשלח קוד כניסה ב SMS.
          </p>
        </div>

        <form onSubmit={onSubmit} className="grid gap-4" noValidate>
          <div className="grid gap-1">
            <label htmlFor="phone" className="text-label font-medium">
              מספר טלפון
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              dir="ltr"
              placeholder="050-123-4567"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
              aria-describedby={error ? 'phone-error' : undefined}
              aria-invalid={error ? true : undefined}
              className="min-h-11 rounded-sm border border-muted bg-surface px-3 text-body text-ink"
            />
            {error && (
              <p id="phone-error" role="alert" className="m-0 text-body-sm text-bad">
                {error}
              </p>
            )}
          </div>

          <Button type="submit" variant="primary" block disabled={isSending || !isValidPhone(phone)}>
            {isSending ? 'שולח קוד' : 'שלח לי קוד'}
          </Button>
        </form>

        <p className="m-0 text-body-sm text-muted">
          {brand.app_title} היא מערכת פנימית. אם המספר שלך לא רשום, פנה/י למנהל/ת הסניף.
        </p>
      </main>
    </div>
  );
}
